import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import emailjs from 'emailjs-com';
import {
  RecaptchaModule, RecaptchaComponent
} from 'ng-recaptcha';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-contact',
  standalone: true,
  imports: [ReactiveFormsModule, RecaptchaModule],
  templateUrl: './contact.component.html',
  styleUrl: './contact.component.scss',
})
export class ContactComponent {
  RE_CAPTCHA_SITE_KEY = environment.RE_CAPTCHA_SITE_KEY;
  serviceId = environment.serviceId;
  templateId = environment.templateId;
  emailJsPublicKey = environment.emailJsPublicKey;
  @ViewChild('recaptchaRef') recaptchaRef!: RecaptchaComponent;
  captchaToken: string | null = null;
  sendingMail = false;

  info = [
    {
      title: 'Email',
      icon: 'email',
      desc: 'shreyashrajiokalaskar@gmail.com',
    },
    {
      title: 'Phone',
      icon: 'phone',
      desc: '+91-7249588034',
    },
    {
      title: 'Location',
      icon: 'location',
      desc: 'Pune, Maharashtra',
    },
  ];

  socials = [
    {
      url: environment.linkedin,
      icon: 'linkedin.png',
    },
    {
      url: environment.github,
      icon: 'svg/github.svg',
    },
  ];
  isBrowser = false;

  contactForm = new FormGroup({
    name: new FormControl('', [Validators.required]),
    email: new FormControl('', [Validators.required, Validators.email]),
    subject: new FormControl('', [Validators.required]),
    message: new FormControl('', [
      Validators.required,
      Validators.maxLength(900),
      Validators.minLength(10),
    ]),
  });

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  sendMail() {
    console.log('SENDING MAIL');
    const templateParams = {
      from_name: this.contactForm.value.name,
      from_email: this.contactForm.value.email,
      message: this.contactForm.value.message,
      subject: this.contactForm.value.subject,
      'g-recaptcha-response': this.captchaToken, // required by EmailJS
    };
    this.sendingMail = true;

    emailjs
      .send(
        this.serviceId,
        this.templateId,
        templateParams,
        this.emailJsPublicKey
      )
      .then(
        () => {
          alert('Mail sent successfully!');
          this.contactForm.reset();
          this.captchaToken = '';
          this.recaptchaRef.reset();
          this.sendingMail = false;
        },
        (err) => {
          console.error(err);
          alert('Failed to send mail.');
          this.captchaToken = '';
          this.recaptchaRef.reset();
          this.sendingMail = false;
        }
      );
  }

  onCaptchaSuccess(event: any) {
    this.captchaToken = event;
    console.log(this.captchaToken);
  }

  onCaptchaError(event: any) {
    console.log(event);
  }

  onCaptchaExpired() {
    console.log(event);
  }

  onCaptchaResolved(token: Event): void {
    // this.captchaToken = token;
    console.log(token);
  }
}
